import ExternalRegisterPage from './ExternalRegisterPage';

const COLUMNS = [
  ['CIS Code', 'cis_code'],
  ['CIP13 Code', 'cip13_code'],
  ['Product Name', 'product_name'],
  ['Pharmaceutical Form', 'pharmaceutical_form'],
  ['Administration Route', 'administration_route'],
  ['MA Status', 'ma_status'],
  ['MA Holder', 'ma_holder'],
  ['MA Date', 'ma_date'],
  ['Active Substance', 'active_substance_designation'],
  ['Dosage', 'dosage'],
  ['Marketing Status', 'marketing_status'],
  ['Reimbursement Rate', 'reimbursement_rate'],
  ['Retail Price (TTC)', 'retail_price_ttc'],
];

const DATE_COLS = new Set(['ma_date', 'packaging_declaration_date']);

const FILTER_CONFIGS = [
  { key: 'cisSearch', label: 'CIS / CIP13 Search', type: 'search', column: 'cis_code', placeholder: 'Search by code...', stripNonDigit: true },
  { key: 'maStatus', label: 'MA Status', column: 'ma_status' },
  { key: 'prodName', label: 'Product Name', column: 'product_name' },
  { key: 'mktStatus', label: 'Marketing Status', column: 'marketing_status' },
  // Gear-hidden
  { key: 'pharmaForm', label: 'Pharmaceutical Form', column: 'pharmaceutical_form' },
  { key: 'adminRoute', label: 'Administration Route', column: 'administration_route' },
  { key: 'maHolder', label: 'MA Holder', column: 'ma_holder' },
  { key: 'maProc', label: 'MA Procedure', column: 'ma_procedure' },
  { key: 'maDate', label: 'MA Date', column: 'ma_date' },
  { key: 'statusBdm', label: 'Status BDM', column: 'status_bdm' },
  { key: 'bdpm', label: 'BDPM', column: 'bdpm' },
  { key: 'europeAmm', label: 'Europe AMM', column: 'europe_amm' },
  { key: 'activeSub', label: 'Active Substance', column: 'active_substance_designation' },
  { key: 'activeSubCode', label: 'Active Substance Code', column: 'active_substance_code' },
  { key: 'dosage', label: 'Dosage', column: 'dosage' },
  { key: 'refDosage', label: 'Reference Dosage', column: 'reference_dosage' },
  { key: 'pkgLabel', label: 'Packaging Label', column: 'packaging_label' },
  { key: 'pkgStatus', label: 'Packaging Status', column: 'packaging_status' },
  { key: 'pkgDate', label: 'Packaging Declaration Date', column: 'packaging_declaration_date' },
  { key: 'reimbRate', label: 'Reimbursement Rate', column: 'reimbursement_rate' },
  { key: 'priceTtc', label: 'Retail Price TTC', column: 'retail_price_ttc' },
  { key: 'reimbInd', label: 'Reimbursement Indications', column: 'reimbursement_indications' },
];

const DEFAULT_FILTERS = ['cisSearch', 'maStatus', 'prodName', 'mktStatus'];

const DETAIL_SECTIONS = [
  {
    title: 'Identification',
    fields: [
      { key: 'cis_code', label: 'CIS Code' },
      { key: 'cip13_code', label: 'CIP13 Code' },
      { key: 'product_name', label: 'Product Name', wide: true },
    ],
  },
  {
    title: 'Composition',
    fields: [
      { key: 'active_substance_designation', label: 'Active Substance', wide: true },
      { key: 'dosage', label: 'Dosage' },
      { key: 'reference_dosage', label: 'Reference Dosage' },
      { key: 'active_substance_code', label: 'Active Substance Code' },
    ],
  },
  {
    title: 'Dosage Form',
    fields: [
      { key: 'pharmaceutical_form', label: 'Pharmaceutical Form' },
      { key: 'administration_route', label: 'Administration Route' },
    ],
  },
  {
    title: 'Authorisation',
    fields: [
      { key: 'ma_status', label: 'MA Status' },
      { key: 'ma_holder', label: 'MA Holder' },
      { key: 'ma_date', label: 'MA Date' },
      { key: 'ma_procedure', label: 'MA Procedure' },
      { key: 'marketing_status', label: 'Marketing Status' },
      { key: 'status_bdm', label: 'Status BDM' },
      { key: 'bdpm', label: 'BDPM' },
      { key: 'europe_amm', label: 'Europe AMM' },
    ],
  },
  {
    title: 'Packaging',
    fields: [
      { key: 'packaging_label', label: 'Packaging Label' },
      { key: 'packaging_status', label: 'Packaging Status' },
      { key: 'packaging_declaration_date', label: 'Packaging Declaration Date' },
    ],
  },
  {
    title: 'Reimbursement',
    fields: [
      { key: 'reimbursement_rate', label: 'Reimbursement Rate' },
      { key: 'retail_price_ttc', label: 'Retail Price TTC' },
      { key: 'reimbursement_indications', label: 'Reimbursement Indications', wide: true },
    ],
  },
];

export default function AnsmSupps() {
  return (
    <ExternalRegisterPage
      source="ansm"
      title="ANSM (BDPM) — France"
      breadcrumb="ANSM France"
      sourceUrl="https://base-donnees-publique.medicaments.gouv.fr/"
      columns={COLUMNS}
      dateColumns={DATE_COLS}
      defaultFilterKeys={DEFAULT_FILTERS}
      filterConfigs={FILTER_CONFIGS}
      prefsKey="ansmFilters"
      detailTitle="ANSM France Record Details"
      detailSections={DETAIL_SECTIONS}
    />
  );
}
